module.exports = __webpack_public_path__ + "6c3d19ea8f7d8860ee7901a9b7783475.svg";